import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase";
import { callPlatformAccess } from "../../platformAccess/api/platformAccessApi";
import { isFinancialTenantScopedActive } from "../auth/FinancialTenantContext";
import { buildFinancialCallableTenant } from "../financialTenantScope";

export function unwrapFinancialCallableData(response) {
  const top = response?.data || {};
  if (top?.data != null && typeof top.data === "object") {
    return top.data;
  }
  return top;
}

function normalizeLegacyFinancialCallableInput(input = {}) {
  if (!input || typeof input !== "object") return input;
  if (input.tenant && typeof input.tenant === "object") {
    return {
      ...input,
      tenant: buildFinancialCallableTenant(input.tenant),
    };
  }
  return input;
}

export async function invokeFinancialCallable(name, input = {}, options = {}) {
  if (isFinancialTenantScopedActive()) {
    const data = await callPlatformAccess(name, input, {
      timeoutMs: options.timeout,
    });
    return { data: { ok: true, data } };
  }

  const fn = httpsCallable(functions, name, {
    ...(options.timeout ? { timeout: options.timeout } : {}),
  });
  return fn(normalizeLegacyFinancialCallableInput(input));
}
